import { render, staticRenderFns } from "./InsightActions.vue?vue&type=template&id=cafef370"
import script from "./InsightActions.vue?vue&type=script&lang=js"
export * from "./InsightActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports